import { ConditionalLogic } from '../../../types/form';

/**
 * Evaluates if a field should be visible based on conditional logic
 */
export const evaluateConditionalLogic = (
  conditions: ConditionalLogic[] | undefined,
  formValues: Record<string, any>
): boolean => {
  if (!conditions || conditions.length === 0) {
    return true; // No conditions = always visible
  }

  // All conditions must be met (AND logic)
  return conditions.every((condition) => {
    const fieldValue = formValues[condition.field];
    const conditionValue = condition.value;
    let conditionMet = false;

    switch (condition.operator) {
      case 'equals':
        conditionMet = fieldValue === conditionValue;
        break;
      case 'not_equals':
        conditionMet = fieldValue !== conditionValue;
        break;
      case 'contains':
        conditionMet = String(fieldValue || '').includes(String(conditionValue));
        break;
      case 'greater_than':
        conditionMet = Number(fieldValue) > Number(conditionValue);
        break;
      case 'less_than':
        conditionMet = Number(fieldValue) < Number(conditionValue);
        break;
      case 'is_empty':
        conditionMet = !fieldValue || fieldValue === '';
        break;
      case 'is_not_empty':
        conditionMet = !!fieldValue && fieldValue !== '';
        break;
      default:
        conditionMet = false;
    }

    // If action is 'hide', invert the result
    return condition.action === 'show' ? conditionMet : !conditionMet;
  });
};

/**
 * Gets all fields that a field depends on (for conditional logic)
 */
export const getFieldDependencies = (
  field: { conditionalLogic?: ConditionalLogic[] }
): string[] => {
  if (!field.conditionalLogic) return [];
  return field.conditionalLogic.map((c) => c.field);
};
